import { MagnifyingGlassIcon } from '@heroicons/react/20/solid';
import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router';
import { useDebounceCallback } from 'usehooks-ts';

type SearchParametersSearchFieldProperties = {
    placeholder?: string;
};

export const SearchParametersSearchField: FunctionComponent<SearchParametersSearchFieldProperties> = ({ placeholder = 'Search' }) => {
    const [searchParameters, setSearchParameters] = useSearchParams();
    const query = searchParameters.get('query') || '';

    const updateQueryTerm = useDebounceCallback((updatedQueryValue) => {
        searchParameters.set('query', updatedQueryValue);

        if (updatedQueryValue === '') {
            searchParameters.delete('query');
        }

        searchParameters.delete('page');

        setSearchParameters(searchParameters);
    }, 500);

    return (
        <div data-testid={'search-parameters-search-field'}>
            <label className="hidden" htmlFor="search">
                <FormattedMessage id={'SEARCH_PARAMETER_SEARCH'} />
            </label>
            <div className="group relative shadow-sm">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <MagnifyingGlassIcon aria-hidden="true" className="size-5 text-gray-400" />
                </div>
                <input
                    autoFocus={true}
                    className="block w-full appearance-none rounded-md border border-gray-200 py-1.5 pl-10 text-sm leading-6 text-gray-600 placeholder:text-gray-400 focus:border-gray-300 focus:ring-0"
                    defaultValue={query}
                    id="search"
                    key={query}
                    name="search"
                    onChange={(event) => {
                        updateQueryTerm(event.currentTarget.value);
                    }}
                    placeholder={placeholder}
                    type="search"
                />
            </div>
        </div>
    );
};
